import { render, staticRenderFns } from "./driverConfig.vue?vue&type=template&id=445a384e"
import script from "./driverConfig.vue?vue&type=script&lang=js"
export * from "./driverConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports